import {Loadable} from 'recoil';

interface DefaultContent<T> {
  content: T[];
}

export function loadableWithDefault<T = unknown>(loadable: Loadable<DefaultContent<T>>, defaultValue: T[]) {
  return loadable.state === 'hasValue' ? loadable.contents.content : defaultValue;
}
